var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeRoleIcon = function SvgChangeRoleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21126_47171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5H5.83333M13.3333 8.95833H12.0833C11.6231 8.95833 11.25 8.58524 11.25 8.125V6.875C11.25 6.41476 11.6231 6.04167 12.0833 6.04167H13.3333C13.7936 6.04167 14.1667 6.41476 14.1667 6.875V8.125C14.1667 8.58524 13.7936 8.95833 13.3333 8.95833ZM13.3333 8.95833C13.3333 8.95833 13.3333 8.95833 13.3333 8.95833ZM8.75 12.5H14.1667M13.3333 17.5H6.66667C4.36548 17.5 2.5 15.6345 2.5 13.3333V6.66667C2.5 4.36548 4.36548 2.5 6.66667 2.5H13.3333C15.6345 2.5 17.5 4.36548 17.5 6.66667V13.3333C17.5 15.6345 15.6345 17.5 13.3333 17.5ZM6.66667 11.0417H7.91667C8.3769 11.0417 8.75 11.4148 8.75 11.875V13.125C8.75 13.5852 8.3769 13.9583 7.91667 13.9583H6.66667C6.20643 13.9583 5.83333 13.5852 5.83333 13.125V11.875C5.83333 11.4148 6.20643 11.0417 6.66667 11.0417Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21126_47171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgChangeRoleIcon as ReactComponent };
export default __webpack_public_path__ + "change-role-icon.svg";